import { post, postStore } from '@/utils/http/http'
import { LIVE_GW_URL } from '@/utils/http/baseUrl'
// 大健康 - 门店系统相关控制器与组件
import StoreController from '@/controllers/storeController/view/store/store.controller.js'
import StoreApiController from '@/controllers/storeController/view/store/storeApi.controller.js'
// 积分列表
export const PostAgentIntegerList = data =>
  post(
    `${LIVE_GW_URL}/integral/v1/h5/userDetail/getUserIntegralDetailList`,
    data,
    true,
    {
      allRes: 1,
    }
  )

// 消耗积分
export const PostOperateAgentInteger = data => {
  const isStore = StoreController.isStore()
  const $apiPost = isStore ? postStore : post
  if (isStore) {
    data = StoreApiController.PostOperateAgentIntegerParams(data)
  }
  return $apiPost(
    `${LIVE_GW_URL}/integral/v1/h5/basic/agentAdminOperateIntegral`,
    data,
    false,
    {
      allRes: 1,
    }
  )
}
